import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Hammer } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/projects", label: "Projects" },
  { to: "/blog", label: "Insights" },
  { to: "/estimator", label: "AI Estimator" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  // close on route change
  React.useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-slate-50/80 border-b border-slate-200/60"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          <div className="w-10 h-10 bg-slate-900 text-[#C5A059] flex items-center justify-center">
            <Hammer size={20} strokeWidth={1.5} />
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-slate-900 text-lg tracking-tight">
              Prime Build Design
            </div>
            <div className="text-[10px] tracking-[0.25em] uppercase text-slate-500">
              Residential Builders · Est. 2014
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" data-testid="primary-nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors ${
                  isActive
                    ? "text-slate-900 border-b-2 border-[#C5A059] pb-1"
                    : "text-slate-600 hover:text-slate-900"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" data-testid="header-cta-quote" className="btn-accent text-sm">
            Get a Quote
          </Link>
        </nav>

        <button
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 text-slate-900"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-slate-50" data-testid="mobile-nav">
          <div className="px-4 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `py-2 text-base font-medium ${
                    isActive ? "text-slate-900" : "text-slate-600"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" data-testid="mobile-cta-quote" className="btn-accent justify-center mt-2">
              Get a Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
